import _ from "lodash";
import decideResultFromStr from "@/js/libs/decideResultId";
import { RESULT_PATTERN } from "@/const/config";
import { resultDataList, getDefaultData } from "@/const/resultConfig";

export function resultId(state) {
  if (!state.userName) return null;
  return decideResultFromStr(state.userName);
}

export function resultName(state, getters) {
  if (getters.resultId < 0) return null;
  return RESULT_PATTERN[getters.resultId];
}

export function resultData(state) {
  if (!state.userName) return null;
  return (
    _.find(resultDataList, result => result.name === state.userName) ||
    getDefaultData(state.userName)
  );
}
